import { constructLastMonthBilling } from "../Factory/factory";
import { LAST_MONTH_BILLING } from "../Reducers/lastMonthBillingReducer";
import { findLastMonthBilling } from "../Util/queries";

export const getLastMonthBilling = () => async (dispatch) => {
    try {
        const response = await findLastMonthBilling();

        const billing = constructLastMonthBilling(
            response.data.partnerMonthlyBillingId,
            response.data.isPaid,
        );

        dispatch({
            type: LAST_MONTH_BILLING,
            payload: billing,
        });
    } catch (e) {
        console.error(e);
        dispatch({
            type: LAST_MONTH_BILLING,
            payload: null,
        });
    }
};